import { createBrowserRouter } from 'react-router-dom';

import Error from './components/errors/GlobalError';
import PublicLayout from './routes/public/layout';
import * as Authenticated from './routes/authenticated';
import NotFoundError from './components/errors/NotFound';
import UnauthorizedError from './components/errors/UnauthorizedError';
import Home from './routes/public/page';
import Products from './routes/public/products/page';
import Product from './routes/public/product/page';
import Imprint from './routes/public/imprint/page';
import DataProtection from './routes/public/dataprotection/page';
import Profile from './routes/authenticated/profile/page';
import Security from './routes/authenticated/security/page';
import TenantLayout from '@/routes/authenticated/tenant/layout';
import Roles from '@/routes/authenticated/tenant/roles/page';
import * as Organizer from './routes/authenticated/organizer';
import PerformanceRecords from '@/routes/authenticated/billing/performanceRecords/page';
import BillingLayout from '@/routes/authenticated/billing/layout';
import Accounts from '@/routes/authenticated/tenant/accounts/page';
import * as Assets from './routes/authenticated/assets/';

import * as Callbacks from './routes/authenticated/organizer/callbacks';
import * as TimeRecords from '@/routes/authenticated/organizer/timerecords';
import * as PaymentMethods from './routes/authenticated/billing/paymentMethods';
import Contacts from '@/routes/authenticated/crm/contacts/page';
import Invoices from '@/routes/authenticated/billing/invoices/page';
import Callcenter from '@/routes/authenticated/crm/callcenter/dashboard/page';
import CRMLayout from '@/routes/authenticated/crm/layout';
import ConfirmEmail from './routes/public/confirmEmail/page';
import Register from './routes/public/register/page';
import OfficeLayout from '@/routes/authenticated/office/layout';
import VisitorsPage from '@/routes/authenticated/office/visitors/page';
import CallsPage from '@/routes/authenticated/crm/callcenter/calls/page';
import Teams from '@/routes/authenticated/tenant/teams/page';
// import Apps from '@/routes/authenticated/apps/page';
import WarehouseLayout from '@/routes/authenticated/warehouse/layout';
import Labels from '@/routes/authenticated/warehouse/labels/page';
// import PortalLayout from './routes/authenticated/portal/licenses/layout';
// import M365 from './routes/authenticated/portal/licenses/m365/page';
// import SupportDashboard from './routes/authenticated/portal/support/page';
// import BillingDashboard from './routes/authenticated/portal/billing/page';
// import EmployeeDashboard from './routes/authenticated/portal/employees/page';
// import OnboardingPage from './routes/authenticated/portal/onboarding/information/page';
// import OnboardingSoftwarePage from './routes/authenticated/portal/onboarding/software/page';
// import OnboardingHardware from './routes/authenticated/portal/onboarding/hardware/page';
// import OnboardingPeripherie from './routes/authenticated/portal/onboarding/peripherie/page';
// import MSP from './routes/authenticated/portal/msp/page';
// import SecurityLicenses from './routes/authenticated/portal/licenses/securitylicenses/page';
// import HardwareLicenses from './routes/authenticated/portal/licenses/hardware&softwarelicenses/page';
// import SignatureLicenses from './routes/authenticated/portal/licenses/signaturelicenses/page';
// import CloudTelephonyLicenses from './routes/authenticated/portal/licenses/cloudtelephonylicenses/page';
// import MailSecurity from './routes/authenticated/portal/licenses/mailsecurity/page';
import Administration from './routes/authenticated/tenant/administration/page';
import InterfaceCreator from './routes/authenticated/tenant/interfaces/page';
import M365Callback from './routes/authenticated/tenant/interfaces/m365/callback';
import Organization from './routes/authenticated/tenant/organization/page';
import * as Services from './routes/authenticated/billing/services/';
import Shipments from '@/routes/authenticated/warehouse/shipments/page';
import Buckets from './routes/authenticated/warehouse/buckets/page';
import App from '@/routes/authenticated/apps/name/page';
import CheckoutReturn from '@/routes/authenticated/apps/name/checkoutReturn/page';
import RegisterCheckoutReturn from '@/routes/public/register/registerCheckoutReturn/page';
import ConfirmRegistration from './routes/public/register/confirmRegistration/page';
// import OnboardingFinal from './routes/authenticated/portal/onboarding/final/page';
import Proxy from '@/routes/authenticated/proxy/proxy';
import NfcTools from './routes/authenticated/nfctool/page';
import Tools from './routes/authenticated/office/tools/page';
import CallInfo from '@/routes/authenticated/crm/callcenter/callInfo/page';
import AppsLayout from './routes/authenticated/apps/layout';

import LearningPage from '@/routes/authenticated/learning/page';
import ProjectsPage from '@/routes/authenticated/projects/page';
import SupportPage from '@/routes/authenticated/support/page';
import CoursePage from './routes/authenticated/learning/course/page';
import LearningLayout from './routes/authenticated/learning/layout';
import CallcenterLayout from './routes/authenticated/crm/callcenter/layout';
import ProjectsLayout from './routes/authenticated/projects/layout';
import ProjectPage from './routes/authenticated/projects/project/page';
import ContractsPage from './routes/authenticated/billing/contracts/page';
import ContractPage from './routes/authenticated/billing/contracts/contract/page';
import ContractsInvoicesPage from './routes/authenticated/billing/contracts/invoices/page';
import ContractsSourcesPage from './routes/authenticated/billing/contracts/sources/page';
import SupportRequest from './routes/authenticated/support/request/page';
import SupportLayout from './routes/authenticated/support/layout';
import TimeEntries from './routes/authenticated/office/timeEntries/page';

export const routes = [
  {
    id: 'public',
    errorElement: <Error />,
    element: <PublicLayout />,
    children: [
      { path: '/', element: <Home /> },
      { path: 'products', element: <Products /> },
      { path: 'products/:name', element: <Product /> },
      { path: 'confirm', element: <ConfirmEmail /> },
      { path: 'impressum', element: <Imprint /> },
      { path: 'datenschutz', element: <DataProtection /> },
      { path: 'privacy', element: <DataProtection /> },
      // { path: 'register', element: <Register /> },
      // { path: 'register/:success', element: <RegisterCheckoutReturn /> },
      // {
      //   path: 'register/confirmRegistration',
      //   element: <ConfirmRegistration />,
      // },
    ],
  },
  {
    id: 'register',
    path: 'register',
    element: <Register />,
    errorElement: <Error />,
    children: [
      { path: ':success', element: <RegisterCheckoutReturn /> },
      { path: 'confirmRegistration', element: <ConfirmRegistration /> },
    ],
  },
  {
    loader: Authenticated.loader,
    id: 'auth',
    element: <Authenticated.Layout />,
    errorElement: <UnauthorizedError />,
    children: [
      {
        errorElement: <Error />,
        children: [
          {
            id: 'organizer',
            path: 'organizer',
            element: <Organizer.Layout />,
            children: [
              {
                path: '',
                element: <Organizer.Page />,
                title: 'Dashboard',
                description: 'Ein Überblick über alles was wichtig ist',
              },
              {
                loader: Callbacks.loader,
                id: 'callbacks',
                path: 'callbacks',
                element: <Callbacks.Page />,
                title: 'Rückrufe',
                description: 'Eine Übersicht über alle Rückrufe',
                children: [{ path: ':id' }],
              },
              {
                loader: TimeRecords.loader,
                id: 'timerecords',
                path: 'timerecords',
                element: <TimeRecords.Page />,
                title: 'Zeitbuchungen',
                description: 'Zeitbuchungssystem',
              },
              {
                path: ':id',
                element: <Organizer.Page />,
              },
            ],
          },
          {
            path: 'crm',
            element: <CRMLayout />,
            title: 'CRM',
            description: 'Eine Übersicht über alle Kundenbeziehungen',
            children: [
              { path: ':id' },
              {
                element: <CallcenterLayout />,
                children: [
                  {
                    path: 'callcenter',
                    element: <Callcenter />,
                    title: 'Callcenter',
                    description: 'Auswertung der Telefonanlage',
                  },
                  {
                    path: 'callcenter/calls',
                    element: <CallsPage />,
                    title: 'Anrufe',
                    description: 'Eine Übersicht über alle Anrufe',
                  },
                  {
                    path: 'callcenter/calls/:id',
                    element: <CallInfo />,
                    title: 'Anrufdetails',
                    description: 'Detaillierte Ansicht eines Anrufs',
                  },
                ],
              },
              {
                id: 'parties',
                path: 'parties',
                element: <Contacts />,
                title: 'Firmen und Kontakte',
                description: 'Eine Übersicht über alle Firmen und Kontakte',
                children: [
                  {
                    path: ':id',
                    element: <Contacts />,
                  },
                ],
              },
            ],
          },
          {
            path: 'invoices',
            element: <Invoices />,
            title: 'Rechnungen',
            description: 'erzeugte Rechnungen',
          },
          {
            path: 'billing',
            element: <BillingLayout />,
            title: 'Abrechnung',
            description: 'Verwaltung von Diensten, Verträgen und Rechnungen',
            children: [
              {
                path: 'services',
                element: <Services.Page />,
                title: 'Tanss',
                description: 'Übersicht der Tanss Dienste',
              },
              {
                path: 'services/:id',
                element: <Services.Page />,
              },
              {
                path: 'contracts',
                element: <ContractsPage />,
                title: 'Verträge',
                description: 'Übersicht aller Verträge',
              },
              {
                path: 'contracts/:id',
                element: <ContractPage />,
                title: 'Vertragsdetails',
              },
              {
                path: 'contracts/invoices',
                element: <ContractsInvoicesPage />,
                title: 'Eingangs-RE',
                description: 'Verwaltung der Eingangsrechnungen',
              },
              {
                path: 'contracts/sources',
                element: <ContractsSourcesPage />,
                title: 'Eingangs-Posten',
                description: 'Upload von vertragsrelevanten Dokumenten',
              },
            ],
          },
        ],
      },
      {
        id: 'projects',
        element: <ProjectsLayout />,
        children: [
          {
            path: 'projects',
            title: 'Projekte',
            description: 'Eine Übersicht über alle Projekte',
            element: <ProjectsPage />,
          },
          { path: 'projects/:id', element: <ProjectPage /> },
        ],
      },
      {
        id: 'support',
        element: <SupportLayout />,
        children: [
          {
            path: 'support',
            element: <SupportPage />,
            title: 'Support',
            description: 'Eine Übersicht über alle Supportanfragen',
          },
          { path: 'support/:id', element: <SupportRequest /> },
        ],
      },
      {
        id: 'learning',
        element: <LearningLayout />,
        children: [
          {
            path: 'learning',
            element: <LearningPage />,
            title: 'Lernen',
            description: 'Eine Übersicht über alle Lerninhalte',
          },
          {
            path: 'learning/:id',
            element: <CoursePage />,
          },
        ],
      },
      {
        loader: Assets.loader,
        id: 'assets',
        path: 'assets',
        element: <Assets.Page />,
        title: 'Assets',
        description: 'Eine Übersicht über alle Assets',
        children: [{ path: ':id' }],
      },
      {
        path: 'office',
        element: <OfficeLayout />,
        title: 'Office',
        description: 'Tools zum Büromanagement',
        children: [
          {
            path: 'visitors',
            element: <VisitorsPage />,
            title: 'Besuch',
            description: 'Verwaltung von Besucher:innen',
            children: [{ path: ':id' }],
          },
          {
            path: 'tools',
            element: <Tools />,
            title: 'Werkzeuge',
            description: 'Verwaltung von Werkzeugen',
            children: [{ path: ':id' }],
          },
          {
            path: 'timeentries',
            element: <TimeEntries />,
            title: 'Zeitbuchungen',
            description: 'Verwaltung von Zeitbuchungen',
          },
        ],
      },
      // {
      //   path: 'portal',
      //   element: <PortalLayout />,
      //   title: 'Kundenportal',
      //   description: 'Übersicht für Kunden',
      //   children: [
      //     {
      //       path: 'm365',
      //       element: <M365 />,
      //       title: 'Microsoft365-Dashboard',
      //       description: 'Dashboard mit Überblick über Microsoft Lizenzen',
      //     },
      //     {
      //       path: 'msp',
      //       element: <MSP />,
      //       title: 'MSP-Dashboard',
      //       description: 'Dashboard mit Überblick über MSP Service',
      //     },
      //     {
      //       path: 'securitylicenses',
      //       element: <SecurityLicenses />,
      //       title: 'SecurityLicenses-Dashboard',
      //       description: 'Dashboard mit Überblick über Security Licenses',
      //     },
      //     {
      //       path: 'hardwareandsoftwarelicenses',
      //       element: <HardwareLicenses />,
      //       title: 'HardwareandSoftwareLicenses-Dashboard',
      //       description:
      //         'Dashboard mit Überblick über Hardware and Software Licenses',
      //     },
      //     {
      //       path: 'signaturelicenses',
      //       element: <SignatureLicenses />,
      //       title: 'SignatureLicenses-Dashboard',
      //       description: 'Dashboard mit Überblick über Signature Licenses',
      //     },
      //     {
      //       path: 'cloudtelephonylicenses',
      //       element: <CloudTelephonyLicenses />,
      //       title: 'CloudTelephonyLicenses-Dashboard',
      //       description:
      //         'Dashboard mit Überblick über cloud telephony Licenses',
      //     },
      //     {
      //       path: 'mailsecurity',
      //       element: <MailSecurity />,
      //       title: 'MailSecurityLicenses-Dashboard',
      //       description: 'Dashboard mit Überblick über mail security Licenses',
      //     },
      //     {
      //       path: 'support',
      //       element: <SupportDashboard />,
      //       title: 'Support-Dashboard',
      //       description: 'Dashboard mit Überblick über TANSS',
      //     },
      //     {
      //       path: 'billing',
      //       element: <BillingDashboard />,
      //       title: 'Billing-Dashboard',
      //       description: 'Dashboard mit Überblick über Abrechnung',
      //     },
      //     {
      //       path: 'employees',
      //       element: <EmployeeDashboard />,
      //       title: 'Employee-Dashboard',
      //       description: 'Dashboard mit Überblick über alle Angestellte',
      //     },
      //     {
      //       path: 'onboarding',
      //       element: <OnboardingPage />,
      //       title: 'Onboarding-Formular',
      //       description: 'Neues Onboarding-Formular für Mitarbeitende',
      //     },
      //     {
      //       path: 'onboardingSoftware',
      //       element: <OnboardingSoftwarePage />,
      //       title: 'Onboarding-Formular',
      //       description:
      //         'Softwareauwahl des Onboarding-Formulars für Mitarbeitende',
      //     },
      //     {
      //       path: 'onboardingHardware',
      //       element: <OnboardingHardware />,
      //       title: 'Onboarding-Formular',
      //       description:
      //         'Hardwareauswahl des Onboarding-Formulars für Mitarbeitende',
      //     },
      //     {
      //       path: 'onboardingPeripherie',
      //       element: <OnboardingPeripherie />,
      //       title: 'Onboarding-Formular',
      //       description:
      //         'Druckerauswahl des Onboarding-Formulars für Mitarbeitende',
      //     },
      //     {
      //       path: 'OnboardingFinal',
      //       element: <OnboardingFinal />,
      //       title: 'Onboarding-Formular',
      //       description:
      //         'Druckerauswahl des Onboarding-Formulars für Mitarbeitende',
      //     },
      //   ],
      // },
      {
        path: 'profile',
        element: <Profile />,
        title: 'Profil',
        description: 'Dein Profil',
      },
      {
        path: 'security',
        element: <Security />,
        title: 'Sicherheit',
        description: 'Deine Sicherheitseinstellungen',
      },
      {
        path: 'apps',
        element: <AppsLayout />,
        title: 'Apps',
        description: 'Füge Apps hinzu und verwalte sie',
        children: [
          {
            path: ':name',
            element: <App />,
          },
        ],
      },

      { path: 'apps/:name/:success', element: <CheckoutReturn /> },
      {
        path: 'warehouse',
        element: <WarehouseLayout />,
        title: 'Lager',
        description: 'Eine Übersicht über Lagerbewegungen',
        children: [
          {
            path: 'labels',
            element: <Labels />,
            title: 'Labels',
            description: 'Erstelle und verwalte Etiketten',
            children: [{ path: ':id' }],
          },
          {
            path: 'shipments',
            element: <Shipments />,
            title: 'Lieferungen',
            description: 'Überblicke Lieferungen',
            children: [{ path: ':id' }],
          },
          {
            path: 'buckets',
            element: <Buckets />,
            title: 'Buckets',
            description: 'Überblicke Buckets',
            children: [{ path: ':id' }],
          },
        ],
      },
      {
        path: 'admin',
        element: <TenantLayout />,
        title: 'Tenant',
        description: 'Einstellungen des Tenants',
        children: [
          {
            path: 'accounts',
            element: <Accounts />,
            title: 'Accounts',
            description: 'Identity and Access Management',
            children: [{ path: ':id' }],
          },
          {
            path: 'roles',
            element: <Roles />,
            title: 'Rolen',
            description: 'Rolenverwaltung',
            children: [{ path: ':id' }],
          },
          {
            path: 'teams',
            element: <Teams />,
            title: 'Teams',
            description: 'Teamverwaltung',
            children: [{ path: ':id' }],
          },
          {
            path: 'administration',
            element: <Administration />,
            title: 'Theme',
            description: 'Theme',
            children: [{ path: ':id' }],
          },
          {
            path: 'interfaces',
            element: <InterfaceCreator />,
            title: 'Schnittstellen',
            description: 'Schnittstellen',
            children: [{ path: ':id' }],
          },
          {
            path: 'interfaces/m365/callback',
            element: <M365Callback />,
          },
          {
            path: 'performanceRecords',
            element: <PerformanceRecords />,
            title: 'Leistungsnachweise',
            description: 'Belege für erbrachte Leistungen',
            children: [{ path: ':id' }],
          },
          {
            path: 'invoices',
            element: <Invoices />,
            title: 'Rechnungen',
            description: 'erzeugte Rechnungen',
            children: [{ path: ':id' }],
          },
          {
            path: 'paymentMethods',
            element: <PaymentMethods.Page />,
            title: 'Zahlungsmethoden',
            description: 'Deine Zahlungsmethoden',
          },
          {
            path: 'organization',
            element: <Organization />,
            title: 'Verwaltung',
            description: 'Verwaltung',
            children: [{ path: ':id' }],
          },
        ],
      },
      {
        path: 'proxy',
        element: <Proxy />,
      },
      {
        path: 'tool/:id',
        element: <NfcTools />,
      },
    ],
  },
  {
    path: '*',
    element: <PublicLayout />,
    children: [{ element: <NotFoundError />, path: '*' }],
  },
];

export const flatRoutes = routes
  .reduce((acc, route) => {
    const flattenRoutes = (route, path) => {
      let fullPath = path;

      if (route.path) {
        fullPath = `${fullPath || ''}/${route.path}`;
        acc.push({ ...route, path: fullPath });
      }

      if (route.children) {
        route.children.forEach((child) => flattenRoutes(child, fullPath));
      }
    };

    flattenRoutes(route, route.path);
    return acc;
  }, [])
  .filter((r) => !r.path.includes(':') && r.path !== '*');

const router = createBrowserRouter(routes);

export default router;
